/**
 * GENERATED FILE — DO NOT EDIT BY HAND
 *
 * Regen command: node scripts/sync-fine-tuned-endpoints.mjs
 * Source: Vertex AI tuningJobs REST API (location: us, latest per agent by endTime)
 * Last synced: 2026-06-21 (R8 training completed)
 *
 * This file is the single source of truth for agent→Vertex endpoint routing.
 * See Platinum Anti-Pattern #9 ("Hardcoded Infrastructure Identifiers") in docs/PLATINUM_QUALITY_STANDARDS.md
 */

export const R8_ENDPOINTS: Record<string, string> = {
  brand: 'projects/148015878263/locations/us/endpoints/3647352748216680448',
  curriculum: 'projects/148015878263/locations/us/endpoints/4670514288559915008',
  devops: 'projects/148015878263/locations/us/endpoints/4544413498993541120',
  director: 'projects/148015878263/locations/us/endpoints/7097954487712612352',
  distribution: 'projects/148015878263/locations/us/endpoints/4220154325822865408',
  'event-planner': 'projects/148015878263/locations/us/endpoints/1067634586663518208',
  finance: 'projects/148015878263/locations/us/endpoints/7413206461628547072',
  generalist: 'projects/148015878263/locations/us/endpoints/1720656532632240128',
  hospitality: 'projects/148015878263/locations/us/endpoints/1211749774739374080',
  legal: 'projects/148015878263/locations/us/endpoints/617274623926468608',
  licensing: 'projects/148015878263/locations/us/endpoints/4400298310917685248',
  marketing: 'projects/148015878263/locations/us/endpoints/126382264543084544',
  merchandise: 'projects/148015878263/locations/us/endpoints/3103261618234982400',
  music: 'projects/148015878263/locations/us/endpoints/7588846847095996416',
  producer: 'projects/148015878263/locations/us/endpoints/2004383309156581376',
  publicist: 'projects/148015878263/locations/us/endpoints/3931923949671153664',
  publishing: 'projects/148015878263/locations/us/endpoints/4178777504246398976',
  road: 'projects/148015878263/locations/us/endpoints/3679722370538405888',
  screenwriter: 'projects/148015878263/locations/us/endpoints/5931522184223653888',
  security: 'projects/148015878263/locations/us/endpoints/8849854742759735296',
  social: 'projects/148015878263/locations/us/endpoints/1824239324061761536',
  video: 'projects/148015878263/locations/us/endpoints/5283003837882302464',
};
